import { SUBSCRIPTION_UPDATED_EVENT } from '@/lib/baba-api'
import type { SubscriptionStatus } from '@/lib/baba-api'
import { babaApi } from './babaApi'
import type { AppDispatch } from './store'

export function registerSubscriptionInvalidation(dispatch: AppDispatch): () => void {
  const handler = (e: Event) => {
    const detail = (e as CustomEvent<SubscriptionStatus>).detail
    dispatch(babaApi.util.upsertQueryData('subscriptionStatus', undefined, detail))
    dispatch(babaApi.util.invalidateTags(['Usage']))
  }
  window.addEventListener(SUBSCRIPTION_UPDATED_EVENT, handler as EventListener)
  return () => window.removeEventListener(SUBSCRIPTION_UPDATED_EVENT, handler as EventListener)
}
